import { render, staticRenderFns } from "./HistoryMapClassic.vue?vue&type=template&id=2b71ae7e"
import script from "./HistoryMapClassic.vue?vue&type=script&lang=js"
export * from "./HistoryMapClassic.vue?vue&type=script&lang=js"
import style0 from "./HistoryMapClassic.vue?vue&type=style&index=0&id=2b71ae7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports